import { getAccessToken } from "Helpers/session";
import useSession from "Hooks/session.hook";
import errorHandler from "Utils/error-handler";
import axios from "axios";
import { isEmpty } from "lodash";

const url = `${process.env.API_URL}/${process.env.API_VER}`;

export const fetchPlanScheduleFirstMilePayload = async () => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/routing_algorithm/first_mile/fetch`,
      data: {},
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPlanScheduleFirstMilePayload();
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchPlanScheduleFirstMidMilePayload = async () => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/routing_algorithm/first_mile_mid_mile/fetch`,
      data: {},
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPlanScheduleFirstMidMilePayload();
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchPlanScheduleMidMilePayload = async () => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/routing_algorithm/mid_mile/fetch`,
      data: {},
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPlanScheduleMidMilePayload();
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchPlanScheduleMidLastMilePayload = async () => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/routing_algorithm/mid_mile_last_mile/fetch`,
      data: {},
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPlanScheduleMidLastMilePayload();
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchPlanScheduleEndToEndPayload = async () => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/routing_algorithm/end_to_end/fetch`,
      data: {},
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPlanScheduleEndToEndPayload();
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchPlanScheduleFirstMileResult = async (data) => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/routing_algorithm/first_mile/result/fetch`,
      data: { ...data },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPlanScheduleFirstMileResult(data);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchPlanScheduleFirstMidMileResult = async (data) => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/routing_algorithm/first_mile_mid_mile/result/fetch`,
      data: { ...data },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPlanScheduleFirstMidMileResult(data);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchPlanScheduleMidMileResult = async (data) => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/routing_algorithm/mid_mile/result/fetch`,
      data: { ...data },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPlanScheduleMidMileResult(data);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchPlanScheduleMidLastMileResult = async (data) => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/routing_algorithm/mid_mile_last_mile/result/fetch`,
      data: { ...data },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPlanScheduleMidLastMileResult(data);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchPlanScheduleEndToEndResult = async (data) => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/routing_algorithm/end_to_end/result/fetch`,
      data: { ...data },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchPlanScheduleEndToEndResult(data);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchScheduleVersions = async () => {
  const accessToken = getAccessToken();
  const { org } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/settings/algo/version/list`,
      data: { logisticProviderOrgID: org.logisticProviderOrgID },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchScheduleVersions();
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const uploadPlanSchedule = async (data) => {
  const accessToken = getAccessToken();
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/routing_algorithm/trip/create`,
      data: { ...data },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await uploadPlanSchedule(data);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};
